import { useContext, useEffect, useState } from 'react';
import { Select, Typography } from '@mui/material';
import { strapiRequest } from '../../functions/axiosRequest';
import { LanguageContext } from '../../context/LanguageContext';

export default function CategorySelect({ selectedCategory, setSelectedCategory, textData }){

	const [categories, setCategories] = useState();
	const locale = useContext(LanguageContext);

	//Fetch product categories after translation data becomes available / when language changes
	useEffect(()=>{
		if(textData){
			strapiRequest({
				method: 'get',
				endpoint: 'product-categories',
				params: { sort: 'name', locale: locale.lang.code }
			}).then((response)=>{
				const all=[{documentId:'all', name:textData.repository_category_select_all}, ...response.data];
				setCategories(all);
				setSelectedCategory(all[0]);
			}).catch((error)=>{
				console.log(error);
			});
		}
	},[textData, locale.lang.code]);

	return(
		<>
			<Typography
				sx={{
					fontSize:'0.8rem',
					color:'grey'
				}}
			>
				{textData?.repository_category_select}
			</Typography>
			<Select
				native
				fullWidth
				value={selectedCategory?.documentId}
				onChange={(event)=>{
				const match=categories.find(category=>category.documentId===event.target.value);
					if(match){
						setSelectedCategory(match);
					}
				}}
			>
				{categories?.map((cat, i)=>{
					return(
						<option
							value={cat.documentId}
							key={i}
						>
							{cat.name}
						</option>
					);
				})}
			</Select>
		</>
	);
}
